var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6C10 6.55228 9.55228 7 9 7C8.44772 7 8 6.55228 8 6C8 5.44772 8.44772 5 9 5C9.55228 5 10 5.44772 10 6ZM11.8293 5C11.4175 3.83481 10.3062 3 9 3C7.69378 3 6.58254 3.83481 6.17071 5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H6.17071C6.58254 8.16519 7.69378 9 9 9C10.3062 9 11.4175 8.16519 11.8293 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H11.8293ZM10 18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18ZM11.8293 17C11.4175 15.8348 10.3062 15 9 15C7.69378 15 6.58254 15.8348 6.17071 17H4C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H6.17071C6.58254 20.1652 7.69378 21 9 21C10.3062 21 11.4175 20.1652 11.8293 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H11.8293ZM15 13C14.4477 13 14 12.5523 14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13ZM15 9C13.6938 9 12.5825 9.83481 12.1707 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H12.1707C12.5825 14.1652 13.6938 15 15 15C16.3062 15 17.4175 14.1652 17.8293 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H17.8293C17.4175 9.83481 16.3062 9 15 9Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/Preferences.0caa034a31e771c77c59a2ab324facfc.svg";
export { ForwardRef as ReactComponent };